const locationRedirect = (url: string) => window.location.replace(url)

export default locationRedirect
